import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
// import './custom.css'

import About from './components/About'
import Team from './components/Team';
import Services from './components/Services';
import Footer from './components/Footer';
import Portfolio from './components/Portfolio';
import Testinomials from './components/Testinomials';

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <Layout>
        <Route exact path='/' component={Home} />
        <Route path='/Testinomials' component={Testinomials} />
        <Route path='/Portfolio' component={Portfolio} />
        <Route path='/Footer' component={Footer} />
        <Route path='/Services' component={Services} />
        <Route path='/Team' component={Team} />
        <Route path='/About' component={ About } /> 
      </Layout>
    );
  }
}
